import { Button } from '@mui/material'
import { Add as AddIcon } from '@mui/icons-material'
import { themeColors } from '../../app/layout/theme'

interface PageActionButtonsProps {
  onBulkUpload?: () => void
  onNew?: () => void
  onExport?: () => void
  newLabel?: string
  bulkUploadLabel?: string
  onCustomAction?: () => void
  customActionLabel?: string
}

export const PageActionButtons = ({
  onBulkUpload,
  onNew,
  onExport,
  newLabel = 'New',
  bulkUploadLabel = 'Bulk Upload',
  onCustomAction,
  customActionLabel = 'Action',
}: PageActionButtonsProps) => {
  return (
    <>
      {onExport && (
        <Button
          variant="outlined"
          size="small"
          onClick={onExport}
          sx={{
            borderRadius: '4px',
            textTransform: 'none',
            fontWeight: 600,
            borderColor: themeColors.primary,
            color: themeColors.primary,
          }}
        >
          Export to Excel
        </Button>
      )}
      {onBulkUpload && (
        <Button
          variant="outlined"
          size="small"
          startIcon={<AddIcon sx={{ fontSize: 18 }} />}
          onClick={onBulkUpload}
          sx={{
            borderRadius: '4px',
            textTransform: 'none',
            fontWeight: 600,
            borderColor: themeColors.primary,
            color: themeColors.primary,
          }}
        >
          {bulkUploadLabel}
        </Button>
      )}
      {onCustomAction && (
        <Button
          variant="outlined"
          size="small"
          onClick={onCustomAction}
          sx={{
            borderRadius: '4px',
            textTransform: 'none',
            fontWeight: 600,
            borderColor: themeColors.primary,
            color: themeColors.primary,
          }}
        >
          {customActionLabel}
        </Button>
      )}
      {onNew && (
        <Button
          variant="contained"
          size="small"
          startIcon={<AddIcon />}
          onClick={onNew}
          sx={{
            borderRadius: '4px',
            textTransform: 'none',
            fontWeight: 600,
            background: themeColors.primaryDark,
            boxShadow: 'none',
            '&:hover': {
              background: themeColors.primary,
              boxShadow: 'none',
            },
          }}
        >
          {newLabel}
        </Button>
      )}
    </>
  )
}
